import { createActions, createReducer } from 'reduxsauce'

import EmpenhosAtaService from '../../servicos/DetalhesAtaRegistroPrecoService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaEmpenhosAtaInicio: [],
    buscaEmpenhosAtaSucesso: ['empenhosAta'],
    buscaEmpenhosAtaErro: ['erro'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
}

// Ação para busca completa
Creators.buscaEmpenhosAta = filtro => {
    return dispatch => {
        dispatch(Creators.buscaEmpenhosAtaInicio())
        let serv = new EmpenhosAtaService()
        return serv
            .consultarEmpenhosAta(filtro)
            .then(response => dispatch(Creators.buscaEmpenhosAtaSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaEmpenhosAtaErro(error)))
    }
}

const buscaEmpenhosAtaInicio = (state = INITIAL_STATE, action) => {
    return { ...state, carregando: true, erro: null }
}

const buscaEmpenhosAtaErro = (state = INITIAL_STATE, action) => {
    return { ...state, erro: action.erro, carregando: false }
}

const buscaEmpenhosAtaSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, lista: action.empenhosAta, carregando: false }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_EMPENHOS_ATA_INICIO]: buscaEmpenhosAtaInicio,
    [Types.BUSCA_EMPENHOS_ATA_ERRO]: buscaEmpenhosAtaErro,
    [Types.BUSCA_EMPENHOS_ATA_SUCESSO]: buscaEmpenhosAtaSucesso,
})
